<div id="msd-diary-wrapper">
  <div class="header">
    <h2 class="title">Journal</h2>
    <div id="navigator" [class.one-day-period]="isOneDayPeriod">
      <i class="icon-btn" id="previous-period" i-bs name="chevron-left" (click)="loadPreviousPeriod()" width="20"
        height="20"></i>
      <h3 id="period-text">{{periodText}}</h3>
      <i class="icon-btn" id="next-period" i-bs name="chevron-right" (click)="loadNextPeriod()" width="20"
        height="20"></i>
    </div>
    <div id="actions-wrapper">
      <button id="send-encouragement-button" type="button" class="btn btn-outline-primary btn-outline text-icon"
        *ngIf="canBeEncouraged && patient?.isAppInstalled" (click)="sendEncouragement()">
        Encourager
        <i i-bs name="envelope" width="12" height="12"></i>
      </button>
      <button id="print-button" type="button" class="btn btn-outline-primary btn-outline text-icon" *ngIf="canBePrinted"
        [disabled]="error && isLoading" printSectionId="msd-diary-days-wrapper"
        (click)="print('msd-diary-days-wrapper')">
        Imprimer
        <i i-bs name="printer" width="12" height="12"></i>
      </button>
    </div>
  </div>

  <div id="msd-diary-days-wrapper" *ngIf="!error && !isLoading; else innerLoading">
    <msd-diary-day-column (onCommentEdit)="commentEdit($event)"
                          *ngFor="let day of days"
                          [class.empty-entry]="!day.diaries || day.diaries.length === 0"
                          [day]="day.date"
                          [diaryCommentLoadingId]="diaryCommentLoadingId"
                          [dietitian]="dietitian"
                          [encouragements]="day.encouragements"
                          [diaryTypes]="diaryTypes"
                          [entries]="day.diaries"
                          [name]="day.label">
    </msd-diary-day-column>
  </div>

  <ng-template #innerLoading>
    <ngx-inner-loading class="flex-center" [empty]="false" [error]="!!error" [loading]="isLoading"
      (retry)="loadDiaries()" loadingDescription="Chargement..." [errorDescription]="error" retryButtonText="Réessayer">
    </ngx-inner-loading>
  </ng-template>
</div>
